import { Component, OnDestroy, OnInit, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { volume } from 'src/interface/volumeIssue';
import { ActivatedRoute, Router } from '@angular/router';
import { MainBodyService } from '../../services/main-body.service';
import { responsedata, themeData } from 'src/interface/themesetting';
import { EnvService } from '../../services/env.service';
import { SharedService } from '../../services/shared.service';
import { VolumeService } from '../../services/volume.service';
import { Subscription } from 'rxjs';
import { JournalService } from '../journal.service';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-journal-volume-listing',
    templateUrl: './journal-volume-listing.component.html',
    styleUrls: ['./journal-volume-listing.component.scss']
})
export class JournalVolumeListingComponent implements OnInit, AfterViewInit, OnDestroy {
    volumeData: volume[] = [];
    isMinus: boolean[] = [];
    routeSub: Subscription;
    themeSettingsData: themeData;
    journalId: string;
    journal_id = '';
    journalIdLoaded: boolean;
    fasttrack: boolean;
    volumDataLength: number;
    loading = true;
    volum_list = new Array(4).fill(0);
    issue_cover_image = '';
    volume_id = '';
    containerHeight = 0;
    subscriptionArr: Subscription[] = [];
    temporary_volume: volume[] = [];
    volume_heading = 'journal_listing.volume_issue';
    volume_final = false;
    showCurrentArticlesOnly = false;
    thematicOnly = false;
    volumesAndIssues: boolean;
    currentArticles: boolean;
    isPlatformBrowserStatus = false;
    constructor(
        private mainBodyService: MainBodyService,
        private EnvService: EnvService,
        private route: ActivatedRoute,
        private sharedService: SharedService,
        private volumeService: VolumeService,
        private journalService: JournalService,
        private router: Router,
        private titleService: Title,
        private translate: TranslateService,
        private metatag: Meta, @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.route.url.subscribe(segments => {
            if (segments.some(segment => segment.path === 'fasttrack')) {
                this.fasttrack = true;
            } else {
                this.fasttrack = false;
            }
        });
    }

    ngOnInit(): void {

        this.thematicOnly = this.route.snapshot.url.some(segment => segment.path === 'thematic-collections');
        this.volumesAndIssues = this.route.snapshot.url.some(segment => segment.path === 'volumes');
        this.showCurrentArticlesOnly = this.route.snapshot.url.some(segment => segment.path === 'current-articles');

        const translatesubs = this.translate.get('journal_listing.volume_issue').subscribe((translation: string) => {
            const page_heading = translation;
            if (this.route.snapshot.url[0].path == 'volumes') {
                this.titleService.setTitle(page_heading + ' | ' + 'Journal of British Academy')
                this.metatag.updateTag(
                    { property: 'og:title', content: page_heading },
                );
            } else {
                let formattedStr = this.route.snapshot.url[0].path.split('-') // Split by hyphen
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
                    .join(' ');

                this.titleService.setTitle(formattedStr + ' | ' + 'Journal of British Academy')
                this.metatag.updateTag(
                    { property: 'og:title', content: formattedStr },
                );
            }

        });
        // Verify if you're getting the correct URL
        this.metatag.updateTag(
            { property: 'og:url', content: this.EnvService.siteUrl + this.route.snapshot.url[0].path },
        );
        this.subscriptionArr.push(translatesubs);
        // const page_heading = this.translate.instant('journal_listing.volume_issue');
        // this.titleService.setTitle(page_heading+' | '+this.journalService.journal_displayname)
        this.volume_id = this.route.snapshot.params['volume_id'] != undefined ? this.route.snapshot.params['volume_id'] : this.volume_id;
        const journalidsubs = this.sharedService.getJournalId().subscribe(journalId => {
            this.journal_id = journalId;


            if (this.journalId == undefined) {

                const journalType = { jnl_type: "JNL" }
                const journaltypesubs = this.journalService.getJournals(journalType).subscribe((result) => {
                    this.journal_id = result.data[0].id;
                    this.metatag.updateTag(
                        { property: 'og:type', content: result.data[0].journal_type.type },
                    );

                    // this.metatag.updateTag(
                    //     { property: 'og:image', content: this.EnvService.imageUrl + 'themes/' + result.data[0].journal_cover_image },
                    // );
                    // this.thematicOnly = this.route.snapshot.url.some(segment => segment.path === 'thematic-collections');
                    if (this.thematicOnly) {
                        this.volume_heading = 'app_header.special_issues_jba';
                        const thematicSub = this.volumeService.getThematic(this.journal_id).subscribe(result => {
                            if (result.data) {
                                result.data = result.data.map(volume => {
                                    if (volume.issue_issues && !Array.isArray(volume.issue_issues)) {
                                        volume.issue_issues = Object.values(volume.issue_issues);
                                    }
                                    if (volume.non_issues && !Array.isArray(volume.non_issues)) {
                                        volume.non_issues = Object.values(volume.non_issues);
                                    }
                                    return volume;
                                });
                            }
                            if (this.volume_id != '') {
                                this.volumeData = result.data.filter(volume => volume.volume === this.volume_id);
                                this.volumDataLength = this.volumeData.length
                                this.loading = false;
                            }
                            else {
                                this.volumeData = result.data;
                                this.volumDataLength = this.volumeData.length
                                this.loading = false;
                            }
                            this.temporary_volume = result.data;
                            this.volume_final = true;
                        })
                        this.subscriptionArr.push(thematicSub);
                    }
                    if (!this.thematicOnly) {

                        const volumeSub = this.volumeService.getVolumeIssues(this.journal_id).subscribe(result => {
                            if (result.data) {
                                result.data = result.data.map(volume => {
                                    if (volume.issue_issues && !Array.isArray(volume.issue_issues)) {
                                        volume.issue_issues = Object.values(volume.issue_issues);
                                    }
                                    if (volume.non_issues && !Array.isArray(volume.non_issues)) {
                                        volume.non_issues = Object.values(volume.non_issues);
                                    }
                                    return volume;
                                });
                            }
                            const latestissue = this.volumeService.getLatestIssue(this.journal_id).subscribe(value => {
                                this.temporary_volume = result.data;
                                if (this.showCurrentArticlesOnly) {

                                    this.volume_final = true;
                                    this.volume_heading = 'app_header.current_articles_jba';
                                    const data = result.data.splice(0, 1);
                                    result.data = data.filter(item => {
                                        item.issue_issues = item.issue_issues.filter(issue => issue.issue === value.data[0]['issue']);

                                        return item.issue_issues; // Keep the item if it still has issues
                                    });
                                    this.loading = false;

                                }
                                if (this.volume_id != '') {
                                    this.volumeData = result.data.filter(volume => volume.volume === this.volume_id);
                                    this.volumDataLength = this.volumeData.length
                                    this.loading = false;
                                }
                                else {

                                    this.volumeData = result.data;
                                    this.volumDataLength = this.volumeData.length
                                    this.loading = false;
                                }
                            });
                            this.subscriptionArr.push(latestissue);
                        })
                        this.subscriptionArr.push(volumeSub);

                    }
                    this.mainBodyService.urlchange(true);
                    const getallthemesubs = this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result: responsedata) => {
                        this.themeSettingsData = result.data;
                        if (isPlatformBrowser(this.platformId)) {
                            Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                                const element = "--" + key;
                                const val: string = value;
                                document.documentElement.style.setProperty(element, val);
                            });
                        }
                    });
                    this.subscriptionArr.push(getallthemesubs);
                });
                this.subscriptionArr.push(journaltypesubs);
            }
            else {
                // this.thematicOnly = this.route.snapshot.url.some(segment => segment.path === 'thematic-collections');
                // this.showCurrentArticlesOnly = this.route.snapshot.url.some(segment => segment.path === 'current-articles');
                // if (this.thematicOnly) {
                //     this.volume_heading = 'app_header.special_issues_jba';
                //     if (this.journal_id) {
                //         const thematicSub = this.volumeService.getThematic(this.journal_id).subscribe(result => {
                //             this.volumeData = result.data;
                //             this.volumeData = this.volumeData.filter(item => item.non_issues.length > 0 || item.issue_issues.length > 0);
                //             this.temporary_volume = this.volumeData;
                //             this.volume_final = true;
                //             this.loading = false;
                //         })
                //         this.subscriptionArr.push(thematicSub);
                //     }
                // }
                // if (!this.thematicOnly) {
                //     if (this.journal_id) {
                //         const volumeSub = this.volumeService.getVolumeIssues(this.journal_id).subscribe(result => {
                //             const latestissue = this.volumeService.getLatestIssue(this.journal_id).subscribe(value => {

                //                 this.temporary_volume = result.data;
                //                 if (this.showCurrentArticlesOnly) {
                //                     this.volume_final = true;
                //                     this.volume_heading = 'app_header.current_articles_jba';
                //                     const data = result.data.splice(0, 1);
                //                     result.data = data.filter(item => {
                //                         item.issue_issues = item.issue_issues.filter(issue => issue.issue === value.data[0]['issue']);

                //                         return item.issue_issues; // Keep the item if it still has issues
                //                     });


                //                 }
                //                 if (this.volume_id != '') {
                //                     this.volumeData = result.data.filter(volume => volume.volume === this.volume_id);
                //                     this.volumDataLength = this.volumeData.length
                //                     this.loading = false;
                //                 }
                //                 else {
                //                     this.volumeData = result.data;
                //                     this.volumDataLength = this.volumeData.length
                //                     this.loading = false;
                //                 }
                //             })
                //             this.subscriptionArr.push(latestissue);
                //         });
                //         this.subscriptionArr.push(volumeSub);
                //     }
                // }
                this.mainBodyService.urlchange(true);
                const getallthemesubs = this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result: responsedata) => {
                    this.themeSettingsData = result.data;
                    if (isPlatformBrowser(this.platformId) && this.themeSettingsData && this.themeSettingsData.theme_colors) {
                        Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                            const element = "--" + key;
                            const val: string = value;
                            (document.documentElement.style as any).setProperty(element, val);
                        });
                    }

                });
                this.subscriptionArr.push(getallthemesubs);
            }
            this.issue_cover_image = this.EnvService.articleCoverImage + this.journal_id + '/';
        });
        //  this.subscriptionArr.push(journalidsubs);
        // this.calculateContainerHeight();

        if (isPlatformBrowser(this.platformId)) {
            this.isPlatformBrowserStatus = true;
        }
        const url = this.route.params.subscribe(params => {
            this.sharedService.setUrlParams(params);
        });
        this.subscriptionArr.push(url);

    }
    ngOnDestroy() {
        this.destroyMetaTagsforSEONew();
        this.subscriptionArr.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }
    changeIssue(issue: any) {
        // Regular expression pattern to match 'and'
        const pattern = /and/;
        let outputString: string = 'Issue ' + issue;
        if (issue.match(pattern)) {
            // Replace 'and' with '/'
            outputString = 'Issue ' + issue.replace(pattern, ' & ');
        }

        // Regular expression pattern to match 's' followed by a number
        const nextpattern = /s(\d+)/;

        if (issue.match(nextpattern)) {
            const issue_num = issue.match(nextpattern)[1];
            // Replace 's' followed by a number with 'supplementary issue' followed by that number
            outputString = issue.replace(nextpattern, 'Supplementary issue ' + issue_num);
        }

        if (issue == 'non-issue') {
            outputString = 'Regular articles';
        }

        return outputString;
    }

    goToPage(url: string) {
        this.router.navigate([url])
    }
    // calculateContainerHeight(): void {
    //     const headerHeight = this.getHeaderHeight();
    //     const footerHeight = this.getFooterHeight();
    //     this.containerHeight = window.innerHeight - (headerHeight + footerHeight) - 210;

    // }
    // getHeaderHeight(): number {
    //     const headerElement = this.elementRef.nativeElement.querySelector('.header');
    //     return headerElement ? headerElement.offsetHeight : 0;
    // }

    // getFooterHeight(): number {
    //     const footerElement = this.elementRef.nativeElement.querySelector('.footer');
    //     return footerElement ? footerElement.offsetHeight : 0;
    // }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            const elementHeader = (<HTMLInputElement>document.getElementById("footer"));
            const elementFooter = (<HTMLInputElement>document.getElementById("footer"));
            if ((typeof (elementHeader) != 'undefined' && elementHeader != null) && (typeof (elementFooter) != 'undefined' && elementFooter != null)) {

                const headerHeight = (<HTMLInputElement>document.getElementById("header")).clientHeight;
                const fotterHeight = (<HTMLInputElement>document.getElementById("footer")).clientHeight;
                this.containerHeight = window.innerHeight - (fotterHeight + headerHeight);

            }
        }
    }
    public destroyMetaTagsforSEONew() {
        this.metatag.updateTag(
            { property: 'og:url', content: this.EnvService.siteUrl },
        );
        this.metatag.updateTag(
            { property: 'og:title', content: "Journal of the British Academy" },
        );
        this.metatag.updateTag(
            { property: 'og:description', content: "Journal of the British Academy" },
        );
        // this.metatag.updateTag(
        //     { property: 'og:image', content: this.EnvService.imageUrl + "themes/default_logo.png" },
        // );

    }
    // setNonIssueLink(volume:string){
    //     let url = '';
    //     this.temporary_volume.forEach(element=>{
    //         if(element.volume == volume){
    //             const hasNonIssue = element.non_issues.some(issue => issue.issue === 'non-issue');
    //             if (hasNonIssue) {
    //                 // this.isNonIssue = true;
    //                 url = `/articles/${element.volume}/non-issue/page/1`;
    //             }
    //         }
    //     })
    //     return url;
    // }
    isNonIssuePresent(volume: any): boolean {
        let hasNonIssue = false;

        this.temporary_volume.forEach(element => {
            if (element.volume === volume.volume) {
                hasNonIssue = element.non_issues.some(issue => issue.issue === 'non-issue');
            }
        });

        return hasNonIssue;
    }

    setNonIssueLink(volume: string): string {
        let url = '';

        this.temporary_volume.forEach(element => {
            if (element.volume === volume) {
                const hasNonIssue = element.non_issues.some(issue => issue.issue === 'non-issue');

                if (hasNonIssue) {
                    url = `/articles/${element.volume}/non-issue/page/1`;
                }
            }
        });

        return url;
    }

    setRegularIssueLink(volume: string, issue: string): string {
        let url = '';
        url += '/regular-articles/articles/' + volume + '/' + issue + '/page/' + 1;
        return url;
    }

    setCurrentLink(volume: string, issue: string) {
        let url = '';
        if (this.showCurrentArticlesOnly) {
            url += '/current-articles/articles/' + volume + '/' + issue + '/page/' + 1;
        }
        if (!this.showCurrentArticlesOnly) {
            url += '/articles/' + volume + '/' + issue + '/page/' + 1;
        }
        return url;
    }

    setThematicLink(volume: string, issue: string, identifier: string) {
        let url = '';
        // if (this.thematicOnly) {
        url += '/thematic-collections/articles/' + volume + '/' + issue + '/' + identifier + '/page/' + 1;
        // }
        // if (!this.thematicOnly) {
        //     url += '/articles/' + volume + '/' + issue + '/page/' + 1;
        // }
        return url;
    }

}
